module.exports = __webpack_public_path__ + "img/Slideshow BV EC 2.4af8e84c.png";